var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-content", [
    _c("img", {
      staticClass: "contact-pic",
      attrs: { src: "http://cdn.dongliyuanlin.com/image/contact.jpg", alt: "" }
    }),
    _c(
      "div",
      { staticClass: "contact-detail" },
      [
        _c("page-title", { attrs: { pageName: _vm.pro } }),
        _c("div", { staticClass: "contact-detail_det" }, [
          _c(
            "ul",
            _vm._l(_vm.pageData, function(item) {
              return _c("li", { key: item.id }, [
                _c("span", { staticClass: "first" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _c("span", { staticClass: "second" }, [
                  _vm._v(_vm._s(item.content))
                ])
              ])
            }),
            0
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6206bb68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6206bb68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/us/contact.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6206bb68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/us/contact.vue
// module chunks = 8